import {
  getRequiredAkiLimitationsScope,
  getRequiredAkiLimitationsVersion
} from '@/global/environmentGetters'
import { useUserStore } from '@/stores/user'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { PredictionResultDTO } from '@/generated'

export function useAkiPlugin() {
  const { t } = useI18n()

  const { latestAkiAcceptance } = storeToRefs(useUserStore())

  const REQUIRED_AKI_LIMITATIONS_VERSION = getRequiredAkiLimitationsVersion()
  const REQUIRED_AKI_LIMITATIONS_SCOPE = getRequiredAkiLimitationsScope()

  const hasAcceptedAkiLimitation = computed(() => {
    return latestAkiAcceptance.value?.version === REQUIRED_AKI_LIMITATIONS_VERSION
  })

  const getAkiPredictionTooltipText = (predictionResult?: PredictionResultDTO): string => {
    if (!predictionResult || predictionResult.probabilityTimestamp == null) {
      return t('No current data available')
    }

    const MS_PER_MINUTE = 1000 * 60
    const MS_PER_HOUR = MS_PER_MINUTE * 60

    const diffMs = Math.max(
      0,
      Date.now() - new Date(predictionResult.probabilityTimestamp).getTime()
    )
    const hours = Math.floor(diffMs / MS_PER_HOUR)
    const minutes = Math.floor((diffMs % MS_PER_HOUR) / MS_PER_MINUTE)

    return t('Last updated {hours} hrs {minutes} mins ago', { hours, minutes })
  }

  return {
    hasAcceptedAkiLimitation,
    getAkiPredictionTooltipText,
    REQUIRED_AKI_LIMITATIONS_VERSION,
    REQUIRED_AKI_LIMITATIONS_SCOPE
  }
}
